import { FlaskConical } from "lucide-react";
import { Alert, AlertTitle } from "@/components/ui/alert";

export function TestMemberBanner() {
    return (
        // The banner is a permanent marker rather than a notification, so it
        // must not be announced like an alert whenever the profile opens.
        <Alert
            role="status"
            className="shrink-0 items-center rounded-none border-violet-200 border-x-0 border-t-0 bg-violet-50 text-violet-950"
        >
            <FlaskConical aria-hidden className="size-4 shrink-0" />
            <AlertTitle>Test member</AlertTitle>
        </Alert>
    );
}
